import {MyPlusMain} from '@/components/main/MyPlus';

export default function MyPlus() {
  try {
    return <MyPlusMain />;
  } catch (error) {}
}
